import { i18n } from 'i18n';

export const MONTHS = {
	'1': i18n.t('January'),
	'2': i18n.t('February'),
	'3': i18n.t('March'),
	'4': i18n.t('April'),
	'5': i18n.t('May'),
	'6': i18n.t('June'),
	'7': i18n.t('July'),
	'8': i18n.t('August'),
	'9': i18n.t('September'),
	'10': i18n.t('October'),
	'11': i18n.t('November'),
	'12': i18n.t('December'),
};

export const MONTHS_OPTIONS = Object.keys(MONTHS).map((key) => ({
	label: MONTHS[key as keyof typeof MONTHS],
	value: key,
}));
